import { FC } from 'react'
import { NodeProps } from 'reactflow'

import { EtlNote } from 'components/EtlNote/EtlNote'

import { getIdFromReactFlowId } from 'modules/Canvas/hooks/useCanvasModel/utils'

import { NoteNodeProps } from './models'

export const NoteNode: FC<NodeProps<NoteNodeProps>> = ({
  id,
  data,
  selected
}) => {
  // Remove this once cypress tests for notes are added.
  /* istanbul ignore next */
  return (
    <EtlNote
      id={Number(getIdFromReactFlowId(id))}
      data={data}
      isSelected={selected}
    />
  )
}
